import React from "react";
import DeleteDialog from "./DeleteDialog";
import Button from "@/components/Button";

interface IDeleteComponentProps {
	appObject: {
		appToken: string;
		companyToken: string;
		createdAt: string;
		id: number;
		name: string;
		nextPaymentAt: null | string;
		packageAndroid: string;
		packageIos: string;
	};
	translationObject: any;
}
const DeleteComponent: React.FC<IDeleteComponentProps> = ({
	appObject,
	translationObject,
}) => {
	const [openModal, setModalOpen] = React.useState(false);

	const handleModalClose = () => {
		setModalOpen(false);
	};

	return (
		<div style={{ margin: "1rem 2rem" }}>
			<DeleteDialog
				openModal={openModal}
				handleModalClose={handleModalClose}
				appObjectId={appObject.id}
				appObjectName={appObject.name}
			/>
			<div
				className="MainSection__Container"
				style={{ borderRadius: "6px", backgroundColor: "#F7F7F7" }}
			>
				<div
					className="ApplicationName"
					style={{
						display: "flex",
						alignItems: "center",
						padding: "1.5rem",
					}}
				>
					<span
						style={{
							fontWeight: "bold",
							width: "40%",
							display: "inline-block",
						}}
					>
						{translationObject("application_setting.delete_title")}
					</span>

					<Button
						style={{
							width: "6rem",
							height: "2rem",
							backgroundColor: "#E70505",
							border: "none",
							borderRadius: "4px",
							color: "white",
						}}
						onClick={(e) => {
							setModalOpen(true);
						}}
					>
						{translationObject("application_setting.delete_button")}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default DeleteComponent;
